export default "/assets/images/white-filter.2f5790aba03e005e.webp";